(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('SelectDivisionAddonController', SelectDivisionAddonController);

        SelectDivisionAddonController.$inject = ['$state', 'EquipeCommerciale', 'Principal', 'User', '$window', 'AlertService'];

    function SelectDivisionAddonController($state, EquipeCommerciale, Principal, User, $window, AlertService) {
        var vm = this;
        vm.ecs;
        vm.selectedEc;
        vm.selectEc = selectEc;


        vm.currentAccount = null;

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        if (Principal.hasAnyAuthority(['ROLE_DIVISION_ADMIN'])) {
            init();
        }

        function init(){
            loadEcs();
        }


        function loadEcs () {
            EquipeCommerciale.myEquipesCommerciales({
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.ecs = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function selectEc() {
            User.updateMyEquipeCommerciale({ id: vm.currentAccount.ec.id }, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            $window.location.reload();
        }


        function onSaveError() {
            vm.isSaving = false;
        }

    }
})();

